import { ITheme, IStyle, mergeStyleSets, getTheme, PanelType } from '@fluentui/react';
import React from 'react';
import { BwjSidePanel } from '../../../../framework/components/bwj-side-panel';
import { BwjButtonType } from '../../../../framework/components/bwj-button';
import { fontFamily } from '../../../../app-core/app-theme';

interface ITermsReviewPanelProps {
  content: string;
  showPanel: boolean;
  onDismissPanel: () => void;
}

const getStyleClasses = (theme: ITheme) => {
  const root: IStyle = {
    padding: '1.25rem',
    paddingTop: 0,
    fontFamily: fontFamily,
    fontSize: theme.fonts.medium.fontSize,
    lineHeight: theme.fonts.medium.lineHeight,

    '& h1': {
      fontSize: theme.fonts.xLarge.fontSize,
      lineHeight: theme.fonts.xLarge.lineHeight,
      margin: '0.7em 0',
      padding: 0,
    },
    '& h2': {
      fontSize: theme.fonts.large.fontSize,
      lineHeight: theme.fonts.large.lineHeight,
      margin: '0.7em 0',
      padding: 0,
    },
  };

  return mergeStyleSets({
    root,
  });
}

export const TermsReviewPanel: React.FunctionComponent<ITermsReviewPanelProps> = (props) => {
  const theme = getTheme();
  const cs = getStyleClasses(theme);

  return (
    <BwjSidePanel
      showPanel={props.showPanel}
      title={'BWJ Storm'}
      panelType={PanelType.large}
      footerButtons={[{
        buttonStyle: BwjButtonType.PrimaryStandard,
        text: 'Close',
        onClick: props.onDismissPanel,
      }]}
      onDismiss={props.onDismissPanel}
      closeButtonAriaLabel={'Close Terms of Service panel'}
    >
      <div
        className={cs.root}
        dangerouslySetInnerHTML={{ __html: props.content }}
      />
    </BwjSidePanel>
  );
};
